module.exports = "dist/2ef1a70f5547a506156608293c57840b.svg";